import styled from 'styled-components';

import { getCombinedClassNames } from 'utils/style';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const PaginationWrapper = styled.div.attrs(() => {
  const classNameToAdd = ['u-block-margins', 'flex', 'justify-center'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})`
  ul.pagination {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    margin: 0;
  }
  ul.pagination li {
    display: inline;
  }
  ul.pagination li a {
    cursor: pointer;
    transition: color 150ms ease-in-out;
    color: ${fullConfig.theme.extend.colors.basic['700']};
    float: left;
    padding: 0.5rem;
    text-decoration: none;

    @media (min-width: ${fullConfig.theme.screens.sm}) {
      padding: 0.5rem 0.75rem;
    }
    @media (min-width: ${fullConfig.theme.screens.md}) {
      padding: 0.5rem 1rem;
    }
    @media (min-width: ${fullConfig.theme.screens.lg}) {
      padding: 0.5rem 1.25rem;
    }
  }
  ul.pagination li.disabled {
    opacity: 0.4;
  }
  ul.pagination li.active a {
    color: ${fullConfig.theme.extend.colors.primary.default};
  }
  ul.pagination li a:hover {
    color: ${fullConfig.theme.extend.colors.primary.default};
  }
  ul.pagination li a:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
`;

// eslint-disable-next-line  import/prefer-default-export
export { PaginationWrapper };
